//**************************************************************************************************
//*************************************** utilityService - ES6 module ****************************
//**************************************************************************************************

'use strict';

class UtilityService{
   
    
   //constructor ($http,$q,$rootScope) {
   constructor () {
     
     /*
      this.$http = $http;
      this.$q=$q;
      this.$rootScope =$rootScope; 
   */
    }

 //  static $inject = ['$http','$q','$rootScope'];

   uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
   }
    uuidNow() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16)+'-'+Date.now();
      });
   }
}

export default UtilityService;